// import { detectOverflow, preventOverflow } from '@popperjs/core';
import { getSelectionText, isSelectionExpanded, TEditor } from '@udecode/plate';
import * as React from 'react';
import { usePopper } from 'react-popper';

import { useSlatePluginsStore } from '../../store';

const { useEffect, useState, useCallback } = React;

const virtualReference = {
  getBoundingClientRect() {
    return {
      top: 10,
      left: 10,
      bottom: 20,
      right: 100,
      width: 90,
      height: 10,
    };
  },
};

export const usePopupPosition = ({ editor, element }: { editor?: TEditor; element: any }) => {
  const [elem] = useState(document?.getElementById('document-wrapper'));

  const setHideSelectionTool = useSlatePluginsStore((s) => s.setHideSelectionTool);
  const hideSelectionTool = useSlatePluginsStore((s) => s.hideSelectionTool);

  const selectionExpanded = editor && isSelectionExpanded(editor);
  const selectionText = editor && getSelectionText(editor);

  const { styles, attributes, update } = usePopper(virtualReference as any, element.current, {
    placement: 'top',

    modifiers: elem
      ? [
          {
            name: 'preventOverflow',
            options: {
              boundary: elem ? elem : undefined,
            },
          },
          {
            name: 'offset',
            options: {
              offset: [0, 10],
            },
          },
          {
            name: 'flip',
            options: {
              allowedAutoPlacements: ['top', 'bottom'],
              padding: elem?.clientHeight
                ? {
                    // TODO: Hackiest way to position because of the boundary element not working properly
                    top: -((elem?.clientHeight || 0) * 0.45),
                  }
                : undefined,
              altBoundary: true,
            },
          },
          { name: 'eventListeners', options: { scroll: !hideSelectionTool } },
        ]
      : undefined,
  });

  const show = useCallback(() => {
    if (hideSelectionTool && selectionExpanded) {
      setHideSelectionTool(false);
    }
  }, [hideSelectionTool, selectionExpanded]);

  useEffect(() => {
    if (!selectionText) {
      setHideSelectionTool(true);
    } else if (selectionText && selectionExpanded) {
      setHideSelectionTool(false);
    }
  }, [selectionText?.length, show, selectionExpanded]);
  useEffect(() => {
    element.current && selectionExpanded && setPosition();
  }, [selectionText?.length, selectionExpanded, element]);

  const setPosition = useCallback(() => {
    const domSelection = window.getSelection();
    if (!domSelection || domSelection.rangeCount < 1) return;

    const domRange = domSelection.getRangeAt(0);
    const rect = domRange.getBoundingClientRect();

    virtualReference.getBoundingClientRect = () => rect;
    update?.();
  }, [virtualReference, update]);

  useEffect(() => {
    const elem = document.getElementById('document-wrapper') || document;
    elem?.addEventListener('scroll', setPosition);
    return () => {
      elem?.removeEventListener('scroll', setPosition);
    };
  }, [setPosition]);

  return [
    { ...styles, popper: { ...styles.popper, display: hideSelectionTool ? 'none' : undefined } },
    attributes,
    hideSelectionTool,
  ];
};
